import { defineMessages } from 'react-intl'

const scope = `procurify.components.OrderItemTooltip`

export default defineMessages({
  text: {
    id: `${scope}.text`,
    defaultMessage: 'OrderItemTooltip',
  },
  itemLabel: {
    id: `${scope}.itemLabel`,
    defaultMessage: 'Item',
  },
  skuLabel: {
    id: `${scope}.skuLabel`,
    defaultMessage: 'SKU',
  },
  quantityLabel: {
    id: `${scope}.quantityLabel`,
    defaultMessage: 'Quantity',
  },
  unitCostLabel: {
    id: `${scope}.unitCostLabel`,
    defaultMessage: 'Unit Cost',
  },
  totalCostLabel: {
    id: `${scope}.totalCostLabel`,
    defaultMessage: 'Total Cost',
  },
})
